import { useEffect, useState } from 'react';
import Sidebar from './Sidebar/Sidebar';
import MenuIcon from '@mui/icons-material/Menu';
import { ThemeProvider, useTheme } from '@mui/material/styles';
import { motion } from 'framer-motion';

const Dashboard = ({ activeTab, children }) => {
    const [onMobile, setOnMobile] = useState(false);
    const [toggleSidebar, setToggleSidebar] = useState(false);
    const theme = useTheme();

    useEffect(() => {
        if (window.innerWidth < 600) {
            setOnMobile(true);
        }
    }, []);

    return (
        <ThemeProvider theme={theme}>
            <main className="flex min-h-screen mt-14 sm:min-w-full" style={{ backgroundColor: theme.palette.background.default }}>
                {!onMobile && <Sidebar activeTab={activeTab} />}
                {toggleSidebar && <Sidebar activeTab={activeTab} setToggleSidebar={setToggleSidebar} />}

                <motion.div
                    initial={{ x: 100, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    transition={{ duration: 0.5 }}
                    className="w-full min-h-screen"
                >
                    <div className="flex flex-col gap-6 sm:m-8 p-2 pb-6 overflow-hidden">
                        <button
                            onClick={() => setToggleSidebar(true)}
                            className="sm:hidden w-10 h-10 rounded-full shadow text-white flex items-center justify-center"
                            style={{ backgroundColor: theme.palette.primary.main }}
                        >
                            <MenuIcon />
                        </button>
                        {children}
                    </div>
                </motion.div>
            </main>
        </ThemeProvider>
    );
};

export default Dashboard;
